import lang from 'src/lang.json';
import { getTranslateLang } from 'util/lang';

const langName = getTranslateLang();

console.log('langName', langName);

const newLang = {};
Object.keys(lang).forEach((key) => {
  newLang[key] = Object.prototype.hasOwnProperty.call(lang[key], langName) ? lang[key][langName] : lang[key].en;
  // 也支持把中文作为 key
  const cn = lang[key].cn;
  newLang[cn] = newLang[key];
});

export default {
  install: (Vue) => {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$lang = newLang;
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$t = key => (typeof newLang[key] === 'undefined' ? key : newLang[key]);
  },
};
